module.exports = __webpack_public_path__ + "img/Close.4321118b.svg";